import React, { useEffect, useState } from 'react'
import { KeyboardAvoidingView, StyleSheet, Text, TextInput, TouchableOpacity, View, Image } from 'react-native'
import { Input, Button } from 'native-base'
import { useNavigation } from '@react-navigation/core'
import { auth, db } from '../firebase'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth'
import { setDoc, doc, updateDoc } from 'firebase/firestore'
import { useRecoilValue } from 'recoil'
import { userState } from '../state/atoms'
import { FontAwesome } from '@expo/vector-icons'

const SignupScreen = () => {
    // Local State
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [username, setUsername] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [showPass, setShowPass] = useState(false)
    const [showPassConfirm, setShowPassConfirm] = useState(false)

    // Global State
    const userDataTemplate = useRecoilValue(userState)

    const navigation = useNavigation()

    // Removes listener once signed in
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                navigation.replace('MainContainer')
            }
        })
        return unsubscribe
    }, [])

    // Registration function
    const handleSignup = () => {
        createUserWithEmailAndPassword(auth, email, password)
            .then(async (userCredential) => {
                const userID = userCredential.user.uid
                await setDoc(doc(db, 'users', userID), userDataTemplate)
                await updateDoc(doc(db, 'users', userID), {
                    ...userDataTemplate,
                    first_name: firstName,
                    last_name: lastName,
                    username: username,
                    email: email,
                })
            })
            .catch((error) => {
                const errorCode = error.code
                const errorMessage = error.message
                console.log(errorCode, errorMessage)
            })
            .finally(() => {
                handleLogin()
            })
    }

    // Login Auth check
    const handleLogin = () => {
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredentials) => {
                const user = userCredentials.user
                console.log('Logged in with: ', user.email)
            })
            .catch((error) => alert(error.message))
    }

    return (
        <KeyboardAvoidingView style={styles.container} behavior="padding">
            <Image style={styles.homeLogo} source={require('../assets/logos/ZHOnly.png')} />
            <View style={styles.inputContainer}>
                <Input style={styles.emailField} autoCapitalize="none" keyboardType="text" autoCorrect={false} placeholder="First Name" value={firstName} onChangeText={(text) => setFirstName(text)} />
                <Input style={styles.emailField} autoCapitalize="none" keyboardType="text" autoCorrect={false} placeholder="Last Name" value={lastName} onChangeText={(text) => setLastName(text)} />
                <Input style={styles.emailField} autoCompleteType="emailAddress" autoCapitalize="none" keyboardType="email-address" autoCorrect={false} placeholder="Email" value={email} onChangeText={(text) => setEmail(text)} />
                <Input style={styles.emailField} autoCapitalize="none" keyboardType="text" autoCorrect={false} placeholder="Desired User Name" value={username} onChangeText={(text) => setUsername(text)} />
                <Input
                    style={styles.passwordField}
                    placeholder="Password"
                    type={showPass ? 'text' : 'password'}
                    value={password}
                    onChangeText={(text) => setPassword(text)}
                    InputRightElement={
                        <TouchableOpacity style={{ marginRight: 10 }} onPress={() => setShowPass(!showPass)}>
                            <FontAwesome name={showPass ? 'eye-slash' : 'eye'} size={16} color="#6c387a" />
                        </TouchableOpacity>
                    }
                />
                {/* <Input
                    style={styles.passwordField}
                    placeholder="Confirm Password"
                    type={showPassConfirm ? 'text' : 'password'}
                    value={confirmPassword}
                    onChangeText={(text) => setConfirmPassword(text)}
                    InputRightElement={
                        <TouchableOpacity style={{ marginRight: 10 }} onPress={() => setShowPassConfirm(!showPassConfirm)}>
                            <FontAwesome name={showPass ? 'eye-slash' : 'eye'} size={16} color="#6c387a" />
                        </TouchableOpacity>
                    }
                /> */}
                <Text style={{ color: 'gray', textAlign: 'center' }}>
                    By creating an account, you acknowledge and agree to{' '}
                    <TouchableOpacity style={{ marginBottom: -4 }} onPress={() => navigation.navigate('Terms')}>
                        <Text style={{ color: 'blue' }}>Terms of Use</Text>
                    </TouchableOpacity>{' '}
                    and{' '}
                    <TouchableOpacity style={{ marginBottom: -4 }} onPress={() => navigation.navigate('Privacy')}>
                        <Text style={{ color: 'blue' }}>Privacy Policy</Text>
                    </TouchableOpacity>
                </Text>
            </View>
            <View style={styles.buttonContainer}>
                <TouchableOpacity onPress={handleSignup} style={[styles.button, styles.buttonOutline]}>
                    <Text style={styles.buttonOutlineText}>Create Account</Text>
                </TouchableOpacity>
                <View style={styles.secondaryActions}>
                    <TouchableOpacity onPress={() => navigation.navigate('Login')} style={styles.secondaryButton}>
                        <Text style={styles.secondaryActionText}>
                            Already have an account? <Text style={{ color: 'blue' }}>Log in</Text>
                        </Text>
                    </TouchableOpacity>
                </View>
            </View>
        </KeyboardAvoidingView>
    )
}

export default SignupScreen

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    inputContainer: {
        width: '80%',
        height: 400,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    emailField: {
        backgroundColor: '#fff',
        borderRadius: 5,
        height: 50,
        fontSize: 16,
    },
    passwordField: {
        backgroundColor: '#fff',
        borderRadius: 5,
        height: 50,
        fontSize: 16,
    },
    secondaryActions: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 10,
        width: '100%',
    },
    secondaryActionText: {
        color: 'gray',
        fontSize: 16,
    },
    buttonContainer: {
        width: '80%',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 40,
    },
    button: {
        backgroundColor: '#6c387a',
        width: '100%',
        padding: 15,
        borderRadius: 5,
        alignItems: 'center',
    },
    buttonOutline: {
        backgroundColor: 'white',
        marginTop: 15,
        borderColor: '#6c387a',
        borderWidth: 2,
    },
    buttonText: {
        color: 'white',
        fontWeight: '700',
        fontSize: 16,
    },
    buttonOutlineText: {
        color: '#6c387a',
        fontWeight: '700',
        fontSize: 16,
    },
    homeLogo: {
        width: '45%',
        height: undefined,
        aspectRatio: 205 / 152,
        marginBottom: 20,
    },
})
